import { useTranslation } from 'react-i18next'

import { Container } from 'src/components/Container/Container'
import { Headline } from 'src/components/Headline/Headline'
import { Link } from 'src/components/Link/Link'
import { ProductBadge } from 'src/components/ProductBadge/ProductBadge'
import { Rating } from 'src/components/Rating/Rating'
import { Text } from 'src/components/Text/Text'
import { getBadgeVariant } from 'src/functions/product/getBadgeVariant'
import { removeBioOrganic } from 'src/functions/product/removeBioOrganic'

import styles from './ProductHeadline.module.scss'

import type { Product } from 'src/data/graphql-generated'
import type { ProductRating } from 'src/types/Product'

interface ProductHeadlineProps {
  product: Product
  rating: ProductRating
  descriptionHtml: Product['descriptionHtml']
}

export const ProductHeadline = ({ product, rating, descriptionHtml }: ProductHeadlineProps) => {
  const { t } = useTranslation()

  const { title } = product

  const { average, count } = rating

  const badgeVariant = getBadgeVariant(product)

  return (
    <Container className={styles.container}>
      <Headline variant="h1">{removeBioOrganic(title)}</Headline>

      <div className={styles.badgeAndRatingContainer}>
        <ProductBadge badgeVariant={badgeVariant} insideCard={false} />

        {count > 0 && (
          <div className={styles.ratingsContainer}>
            <Rating rating={average} size="md" />
            <Link href="#reviews" underline={false} data-analytics-id="ratings-and-reviews">
              <Text variant="span" x-small>
                {t('pdp.ratingCustomerReviews', { count })}
              </Text>
            </Link>
          </div>
        )}
      </div>

      <div className="textblock" dangerouslySetInnerHTML={{ __html: descriptionHtml || '' }} suppressHydrationWarning />
    </Container>
  )
}
